/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { CommodityGroupsResponse, CreateCommodityGroupsRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CommodityGroups<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name OptionsCommodityGroups
   * @request OPTIONS:/commodityGroups/{id}
   */
  optionsCommodityGroups = (id: string, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodityGroups/${id}`,
      method: 'OPTIONS',
      ...params,
    });
  /**
   * No description
   *
   * @name GetCommodityGroups
   * @request GET:/commodityGroups
   * @secure
   */
  getCommodityGroups = (params: RequestParams = {}) =>
    this.request<CommodityGroupsResponse, any>({
      path: `/commodityGroups`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name CreateCommodityGroups
   * @request POST:/commodityGroups
   * @secure
   */
  createCommodityGroups = (data: CreateCommodityGroupsRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodityGroups`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCommodityGroups2
   * @request OPTIONS:/commodityGroups
   * @originalName optionsCommodityGroups
   * @duplicate
   */
  optionsCommodityGroups2 = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/commodityGroups`,
      method: 'OPTIONS',
      ...params,
    });
}
